__turbopack_context__.v({
  "filterSkeleton": "ProductListingPage-module-scss-module__1NfA7a__filterSkeleton",
  "filterSkeletonCount": "ProductListingPage-module-scss-module__1NfA7a__filterSkeletonCount",
  "filterSkeletonItem": "ProductListingPage-module-scss-module__1NfA7a__filterSkeletonItem",
  "gridSkeleton": "ProductListingPage-module-scss-module__1NfA7a__gridSkeleton",
  "heroSkeleton": "ProductListingPage-module-scss-module__1NfA7a__heroSkeleton",
  "heroSkeletonHeading": "ProductListingPage-module-scss-module__1NfA7a__heroSkeletonHeading",
  "heroSkeletonSubheading": "ProductListingPage-module-scss-module__1NfA7a__heroSkeletonSubheading",
  "page": "ProductListingPage-module-scss-module__1NfA7a__page",
  "productSkeleton": "ProductListingPage-module-scss-module__1NfA7a__productSkeleton",
  "productSkeletonImage": "ProductListingPage-module-scss-module__1NfA7a__productSkeletonImage",
  "productSkeletonPrice": "ProductListingPage-module-scss-module__1NfA7a__productSkeletonPrice",
  "productSkeletonText": "ProductListingPage-module-scss-module__1NfA7a__productSkeletonText",
  "shimmer-slide": "ProductListingPage-module-scss-module__1NfA7a__shimmer-slide",
});
